import numeral from "numeral"

export const currency = (value) => {
  return numeral(value).format('0,0.00');
};

export const number = (value) => {
  return numeral(value).format('0,0');
};